export default "__VITE_ASSET__DYNci4SF__"